const carousels = document.querySelectorAll(".Carousel");

if (carousels.length) {
  const isTablet = window.innerWidth < 1024;

  const options = {
    pageDots: false,
    prevNextButtons: false,
    wrapAround: !isTablet ? true : false,
    percentPosition: false,
    fade: true,
    cellAlign: !isTablet ? "center" : "left",
  };

  carousels.forEach((carousel) => {
    // eslint-disable-next-line no-undef, no-unused-vars
    const flkty = new Flickity(carousel, options);

    if (!isTablet) {
      const items = carousel.querySelectorAll(".Carousel-item");

      items.forEach((item) => {
        item.addEventListener("mouseenter", () => {
          const id = item.getAttribute("data-id");

          document
            .querySelector(`.Carousel-itemTitle[data-id='${id}']`)
            .classList.add("--visible");
        });

        item.addEventListener("mouseleave", () => {
          document
            .querySelector(".Carousel-itemTitle.--visible")
            .classList.remove("--visible");
        });
      });
    } else {
      carousel.parentElement
        .querySelector(`.Carousel-itemTitle[data-index='${0}']`)
        .classList.add("--visible");

      flkty.on("change", (i) => {
        carousel.parentElement
          .querySelector(".Carousel-itemTitle.--visible")
          .classList.remove("--visible");

        carousel.parentElement
          .querySelector(`.Carousel-itemTitle[data-index='${i}']`)
          .classList.add("--visible");
      });
    }
  });
}
